import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

function ActionList({ items }: { items: string[] }) {
  return (
    <ul className="space-y-1">
      {items.map((item) => (
        <li key={item} className="leading-relaxed">
          {item}
        </li>
      ))}
    </ul>
  );
}

export function BillingCapabilitiesCard({ answer }: Props) {
  const supported = answer.supported_actions || [];
  const approvalRequired = answer.approval_required_actions || [];
  const unsupported = answer.unsupported_actions || [];
  const tryLine = answer.content.split('\n').find((line) => line.startsWith('Try:'));

  return (
    <article className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-950">
      <div className="mb-3 flex items-center gap-2">
        <span className="rounded bg-emerald-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide">
          Billing actions
        </span>
      </div>

      {supported.length > 0 && (
        <section className="mb-3">
          <div className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-emerald-700">
            Supported now
          </div>
          <ActionList items={supported} />
        </section>
      )}

      {approvalRequired.length > 0 && (
        <section className="mb-3 rounded border border-amber-200 bg-amber-50 p-2 text-amber-950">
          <div className="mb-1 text-[11px] font-semibold uppercase tracking-wide">Approval required</div>
          <ActionList items={approvalRequired} />
        </section>
      )}

      {unsupported.length > 0 && (
        <section className="mb-3 rounded border border-slate-200 bg-white/70 p-2 text-slate-800">
          <div className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-slate-600">
            Not yet supported
          </div>
          <ActionList items={unsupported} />
        </section>
      )}

      {tryLine && <p className="whitespace-pre-line leading-relaxed">{tryLine}</p>}
    </article>
  );
}
